import { render, staticRenderFns } from "./NavigateTo.vue?vue&type=template&id=cd6f0b64&scoped=true"
import script from "./NavigateTo.vue?vue&type=script&lang=js"
export * from "./NavigateTo.vue?vue&type=script&lang=js"
import style0 from "./NavigateTo.vue?vue&type=style&index=0&id=cd6f0b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6f0b64",
  null
  
)

export default component.exports